import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/i18n/LanguageContext';
import { SiteLayout } from '@/components/common/SiteLayout';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import VisionPage from '@/pages/VisionPage';
import EmblemPage from '@/pages/EmblemPage';
import FounderPage from '@/pages/FounderPage';
import AgendaPage from '@/pages/AgendaPage';
import DashboardPage from '@/pages/DashboardPage';
import AspirantPage from '@/pages/AspirantPage';
import ManifestoPage from '@/pages/ManifestoPage';
import DialoguePage from '@/pages/DialoguePage';
import RoadmapPage from '@/pages/RoadmapPage';
import ConstitutionPage from '@/pages/ConstitutionPage';
import NationalPage from '@/pages/NationalPage';
import JoinPage from '@/pages/JoinPage';
import NewsPage from '@/pages/NewsPage';
import TransparencyPage from '@/pages/TransparencyPage';
import ContactPage from '@/pages/ContactPage';
import AdminPage from '@/pages/AdminPage';
import NotFoundPage from '@/pages/NotFoundPage';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/vision" element={<VisionPage />} />
              <Route path="/emblem" element={<EmblemPage />} />
              <Route path="/founder" element={<FounderPage />} />
              <Route path="/agenda" element={<AgendaPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/aspirant" element={<AspirantPage />} />
              <Route path="/manifesto" element={<ManifestoPage />} />
              <Route path="/dialogue" element={<DialoguePage />} />
              <Route path="/roadmap" element={<RoadmapPage />} />
              <Route path="/constitution" element={<ConstitutionPage />} />
              <Route path="/national" element={<NationalPage />} />
              <Route path="/join" element={<JoinPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/transparency" element={<TransparencyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
